import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { createStandaloneToast } from '@chakra-ui/toast';

const toastImpl = createStandaloneToast({
	defaultOptions: {
		title: 'Algo deu errado.',
		description: 'Por favor contate a equipe de Produtos e informe o erro.',
		status: 'error',
		duration: 8000,
		isClosable: true,
	},
});

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		// You can also log the error to an error reporting service
		console.warn(error, errorInfo);
		if (this.state.hasError && this.props.isToast) {
			toastImpl();
		}
	}

	render() {
		if (this.state.hasError && !this.props.isToast) {
			// You can render any custom fallback UI
			{
				<Box {...elementProps}>
					<Box {...elementBorder}>
						<Text {...textStyle}>Algo deu errado. Por favor contate a equipe de Produtos</Text>
					</Box>
				</Box>;
			}
		}

		return this.props.children;
	}
}

export default ErrorBoundary;

const elementProps = {
	bg: 'white',
	height: '100%',
	width: '100%',
	backgroundColor: '#ff8787',
	padding: '0',
	d: 'flex',
	sx: { ':hover': { cursor: 'grab' } },
};

const elementBorder = {
	border: 'solid 2px #9e2424',
	borderRadius: '3px',
	margin: '8px 8px 5px 8px',
	w: '100%',
	verticalAlign: 'middle',
	d: 'flex',
};

const textStyle = {
	padding: '4px',
	color: '#9e2424',
	fontWeight: 700,
	fontSize: '13px',
	alignSelf: 'center',
	margin: '0 auto',
};
